import { render, staticRenderFns } from "./marketObservationModal.vue?vue&type=template&id=b522c414"
import script from "./marketObservationModal.vue?vue&type=script&lang=js"
export * from "./marketObservationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports